import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesPlannedTransportAnomaliesOriginReport
  from '../../components/PredesPlannedTransportAnomaliesOriginReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesPlannedTransportAnomaliesOriginDetailsSelectors';

export function PredesPlannedTransportAnomaliesOriginDetailsContainer(props) {
  return (
    <PredesPlannedTransportAnomaliesOriginReport
      reportId={ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesPlannedTransportAnomaliesOriginDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesPlannedTransportAnomaliesOriginDetailsContainer);
